import React from 'react'
import CustomData from './CustomData'
import { data } from './data/projectData';

function Projects() {
  return (
    <>
      <CustomData
      data={data}
      section="My Projects"
      para = "I will provide you high standard and clean website's for your business using latest technologies. InshaAllah."
      />
    </>
  )
}

export default Projects
